import {createAction} from '@reduxjs/toolkit';


export const initialState = {
  modeDark: 'dark',
};

export const modeDark = createAction('root/changeModeDark');
